type Build = (m: RegExpMatchArray, sub: (s: string) => string) => readonly [string, string, string, string];

const plural = (n: string, one: string, many: string) => (Number(n) > 1 ? many : one);

/** Noms de cocktails de la boutique : ils s'écrivent pareil dans toutes les langues. */
const SHOP_FLAVORS = "Moscow Mule|Pink Lady|Gin Tonic|Mojito|Pornstar Martini";

// Textes contenant des valeurs dynamiques (compteurs, noms, numéros d'étape…)
export const PATTERNS: ReadonlyArray<readonly [RegExp, Build]> = [
  [/^(\d+),(\d+) ?%$/, (m) => [`${m[1]}.${m[2]}%`, `${m[1]},${m[2]} %`, `${m[1]},${m[2]}%`, `${m[1]},${m[2]} %`]],
  [/^25cl · (\d+),(\d+) ?%$/, (m) => [`25cl · ${m[1]}.${m[2]}%`, `25cl · ${m[1]},${m[2]} %`, `25cl · ${m[1]},${m[2]}%`, `25cl · ${m[1]},${m[2]} %`]],
  [/^(\d+) chances?$/i, (m) => [
    `${m[1]} ${plural(m[1], "chance", "chances")}`,
    `${m[1]} ${plural(m[1], "Chance", "Chancen")}`,
    `${m[1]} ${plural(m[1], "possibilità", "possibilità")}`,
    `${m[1]} ${plural(m[1], "oportunidad", "oportunidades")}`,
  ]],
  [/^Continuer avec (\d+) chances? →$/, (m) => [
    `Continue with ${m[1]} ${plural(m[1], "chance", "chances")} →`,
    `Weiter mit ${m[1]} ${plural(m[1], "Chance", "Chancen")} →`,
    `Continua con ${m[1]} possibilità →`,
    `Continuar con ${m[1]} ${plural(m[1], "oportunidad", "oportunidades")} →`,
  ]],
  [/^(\d+) réseaux? validés?$/, (m) => [
    `${m[1]} ${plural(m[1], "account", "accounts")} verified`,
    `${m[1]} ${plural(m[1], "Kanal", "Kanäle")} bestätigt`,
    `${m[1]} social ${plural(m[1], "verificato", "verificati")}`,
    `${m[1]} ${plural(m[1], "red verificada", "redes verificadas")}`,
  ]],
  [/^Tour bonus débloqué ! Tu as (\d+) tours? restants?\.$/, (m) => [
    `Bonus spin unlocked! You have ${m[1]} ${plural(m[1], "spin", "spins")} left.`,
    `Bonus-Drehung freigeschaltet! Du hast noch ${m[1]} ${plural(m[1], "Drehung", "Drehungen")}.`,
    `Giro bonus sbloccato! Ti ${plural(m[1], "resta", "restano")} ${m[1]} ${plural(m[1], "giro", "giri")}.`,
    `¡Tirada extra desbloqueada! Te ${plural(m[1], "queda", "quedan")} ${m[1]} ${plural(m[1], "tirada", "tiradas")}.`,
  ]],
  [/^FAIRE TOURNER · (\d+) TOURS$/, (m) => [`SPIN · ${m[1]} SPINS`, `DREHEN · ${m[1]} DREHUNGEN`, `GIRA · ${m[1]} GIRI`, `GIRAR · ${m[1]} TIRADAS`]],
  [/^Réserver (\d+) places →$/, (m) => [`Book ${m[1]} spots →`, `${m[1]} Plätze reservieren →`, `Prenota ${m[1]} posti →`, `Reservar ${m[1]} plazas →`]],
  [/^Erreur serveur \((\d+)\)\.$/, (m) => [`Server error (${m[1]}).`, `Serverfehler (${m[1]}).`, `Errore del server (${m[1]}).`, `Error del servidor (${m[1]}).`]],
  [/^Étape (\d+) - (.+)$/, (m, sub) => [`Step ${m[1]} - ${sub(m[2])}`, `Schritt ${m[1]} - ${sub(m[2])}`, `Passaggio ${m[1]} - ${sub(m[2])}`, `Paso ${m[1]} - ${sub(m[2])}`]],
  [/^Canette (.+) Cartel Paradise 25cl — (.+)$/, (m, sub) => [
    `${m[1]} Cartel Paradise 25cl can — ${sub(m[2])}`,
    `${m[1]} Cartel Paradise 25cl-Dose — ${sub(m[2])}`,
    `Lattina ${m[1]} Cartel Paradise 25cl — ${sub(m[2])}`,
    `Lata ${m[1]} Cartel Paradise 25cl — ${sub(m[2])}`,
  ]],
  [/^(.+) — Cocktail RTD (.+) \| Cartel Paradise$/, (m, sub) => [
    `${sub(m[1])} — ${sub(m[2])} RTD Cocktail | Cartel Paradise`,
    `${sub(m[1])} — RTD-Cocktail ${sub(m[2])} | Cartel Paradise`,
    `${sub(m[1])} — Cocktail RTD ${sub(m[2])} | Cartel Paradise`,
    `${sub(m[1])} — Cóctel RTD ${sub(m[2])} | Cartel Paradise`,
  ]],
  [/^(.+) \| Cartel Paradise$/, (m, sub) => [`${sub(m[1])} | Cartel Paradise`, `${sub(m[1])} | Cartel Paradise`, `${sub(m[1])} | Cartel Paradise`, `${sub(m[1])} | Cartel Paradise`]],
  [/^(.+) — Cartel Paradise$/, (m, sub) => [`${sub(m[1])} — Cartel Paradise`, `${sub(m[1])} — Cartel Paradise`, `${sub(m[1])} — Cartel Paradise`, `${sub(m[1])} — Cartel Paradise`]],

  // Boutique : compteurs, récapitulatif, libellés d'accessibilité, panier et confirmation
  [/^(\d+)\/(\d+) canettes$/, (m) => [`${m[1]}/${m[2]} cans`, `${m[1]}/${m[2]} Dosen`, `${m[1]}/${m[2]} lattine`, `${m[1]}/${m[2]} latas`]],
  [/^Encore (\d+) cartons? et ta commande part sur palette filmée\.$/, (m) => [
    `${m[1]} more ${plural(m[1], "case", "cases")} and your order ships on a shrink-wrapped pallet.`,
    `Noch ${m[1]} ${plural(m[1], "Karton", "Kartons")}, und deine Bestellung geht auf einer folierten Palette raus.`,
    `Ancora ${m[1]} ${plural(m[1], "cartone", "cartoni")} e il tuo ordine parte su bancale pellicolato.`,
    `${plural(m[1], "Falta", "Faltan")} ${m[1]} ${plural(m[1], "caja", "cajas")} para que tu pedido salga en un palé retractilado.`,
  ]],
  [/^(?:(\d+) cartons · )?(\d+) canettes(?: (· sur palette)| \+ (.+))?$/, (m, sub) => {
    const merch = m[4] ? ` + ${sub(m[4])}` : "";
    const onPallet = m[3] !== undefined;
    return [
      `${m[1] ? `${m[1]} cases · ` : ""}${m[2]} cans${merch}${onPallet ? " · on a pallet" : ""}`,
      `${m[1] ? `${m[1]} Kartons · ` : ""}${m[2]} Dosen${merch}${onPallet ? " · auf Palette" : ""}`,
      `${m[1] ? `${m[1]} cartoni · ` : ""}${m[2]} lattine${merch}${onPallet ? " · su bancale" : ""}`,
      `${m[1] ? `${m[1]} cajas · ` : ""}${m[2]} latas${merch}${onPallet ? " · en palé" : ""}`,
    ];
  }],
  [/^(\d+) canettes à composer$/, (m) => [`${m[1]} cans to build`, `${m[1]} Dosen zum Zusammenstellen`, `${m[1]} lattine da comporre`, `${m[1]} latas para componer`]],
  [new RegExp(`^(\\d+) canettes (${SHOP_FLAVORS})$`), (m) => [`${m[1]} ${m[2]} cans`, `${m[1]} ${m[2]}-Dosen`, `${m[1]} lattine ${m[2]}`, `${m[1]} latas de ${m[2]}`]],
  [/^(Ajouter|Retirer) une canette (.+)$/, (m) =>
    m[1] === "Ajouter"
      ? [`Add one ${m[2]} can`, `${m[2]}-Dose hinzufügen`, `Aggiungi una lattina ${m[2]}`, `Añadir una lata de ${m[2]}`]
      : [`Remove one ${m[2]} can`, `${m[2]}-Dose entfernen`, `Rimuovi una lattina ${m[2]}`, `Quitar una lata de ${m[2]}`],
  ],
  [/^(Ajouter|Retirer) : un carton(?: (.+))?$/, (m) => {
    const flavor = m[2];
    return m[1] === "Ajouter"
      ? [
          flavor ? `Add one ${flavor} case` : "Add one case",
          flavor ? `${flavor}-Karton hinzufügen` : "Karton hinzufügen",
          flavor ? `Aggiungi un cartone ${flavor}` : "Aggiungi un cartone",
          flavor ? `Añadir una caja de ${flavor}` : "Añadir una caja",
        ]
      : [
          flavor ? `Remove one ${flavor} case` : "Remove one case",
          flavor ? `${flavor}-Karton entfernen` : "Karton entfernen",
          flavor ? `Rimuovi un cartone ${flavor}` : "Rimuovi un cartone",
          flavor ? `Quitar una caja de ${flavor}` : "Quitar una caja",
        ];
  }],
  [/^Retirer du panier : (.+)$/, (m, sub) => [`Remove from cart: ${sub(m[1])}`, `Aus dem Warenkorb entfernen: ${sub(m[1])}`, `Rimuovi dal carrello: ${sub(m[1])}`, `Quitar del carrito: ${sub(m[1])}`]],
  [/^(Ajouter|Retirer) : (.+)$/, (m, sub) =>
    m[1] === "Ajouter"
      ? [`Add: ${sub(m[2])}`, `Hinzufügen: ${sub(m[2])}`, `Aggiungi: ${sub(m[2])}`, `Añadir: ${sub(m[2])}`]
      : [`Remove: ${sub(m[2])}`, `Entfernen: ${sub(m[2])}`, `Rimuovi: ${sub(m[2])}`, `Quitar: ${sub(m[2])}`],
  ],
  [new RegExp(`^(.+) — (${SHOP_FLAVORS})$`), (m, sub) => [`${sub(m[1])} — ${m[2]}`, `${sub(m[1])} — ${m[2]}`, `${sub(m[1])} — ${m[2]}`, `${sub(m[1])} — ${m[2]}`]],
  [/^Mon panier, (\d+) articles?$/, (m) => [
    `My cart, ${m[1]} ${plural(m[1], "item", "items")}`,
    `Mein Warenkorb, ${m[1]} Artikel`,
    `Il mio carrello, ${m[1]} ${plural(m[1], "articolo", "articoli")}`,
    `Mi carrito, ${m[1]} ${plural(m[1], "artículo", "artículos")}`,
  ]],
  [/^(.+) \+ T-shirt (noir|blanc)$/, (m, sub) => {
    const black = m[2] === "noir";
    return [
      `${sub(m[1])} + ${black ? "black" : "white"} T-shirt`,
      `${sub(m[1])} + ${black ? "schwarzes" : "weißes"} T-Shirt`,
      `${sub(m[1])} + T-shirt ${black ? "nera" : "bianca"}`,
      `${sub(m[1])} + camiseta ${black ? "negra" : "blanca"}`,
    ];
  }],
  [/^Merci pour ta (précommande|commande)$/, (m) => {
    const pre = m[1] === "précommande";
    return [
      `Thank you for your ${pre ? "pre-order" : "order"}`,
      `Danke für deine ${pre ? "Vorbestellung" : "Bestellung"}`,
      `Grazie per il tuo ${pre ? "preordine" : "ordine"}`,
      `Gracias por tu ${pre ? "reserva" : "pedido"}`,
    ];
  }],
  [/^Ta (précommande|commande) est enregistrée$/, (m) => {
    const pre = m[1] === "précommande";
    return [
      `Your ${pre ? "pre-order" : "order"} is registered`,
      `Deine ${pre ? "Vorbestellung" : "Bestellung"} ist registriert`,
      `Il tuo ${pre ? "preordine" : "ordine"} è registrato`,
      pre ? "Tu reserva está registrada" : "Tu pedido está registrado",
    ];
  }],
  [/^Total payé : (.+)$/, (m) => [`Total paid: ${m[1]}`, `Gesamtbetrag bezahlt: ${m[1]}`, `Totale pagato: ${m[1]}`, `Total pagado: ${m[1]}`]],
  [/^Tu regardais « (.+) »\. Laisse-nous tes coordonnées : on te prévient dès que la boutique ouvre\.$/, (m, sub) => [
    `You were looking at “${sub(m[1])}”. Leave us your details: we'll notify you as soon as the shop opens.`,
    `Du hast dir „${sub(m[1])}“ angesehen. Hinterlasse uns deine Daten: Wir benachrichtigen dich, sobald der Shop öffnet.`,
    `Stavi guardando «${sub(m[1])}». Lasciaci i tuoi dati: ti avvisiamo appena il negozio apre.`,
    `Estabas viendo «${sub(m[1])}». Déjanos tus datos: te avisamos en cuanto abra la tienda.`,
  ]],
];
